import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { IconComponent } from '../../../components/icon/icon.component';
import { OverlayToggleDirective } from '../../../components/overlay/overlay-toggle.directive';
import { OverlayComponent } from '../../../components/overlay/overlay.component';
import { ButtonComponent } from '../../../components/button/button.component';

@Component({
  selector: 'td-wb-w8ben-tooltip',
  templateUrl: 'w8ben-form-tooltip.component.html',
  styleUrls: ['w8ben-form-tooltip.component.scss'],
  imports: [
    OverlayToggleDirective,
    IconComponent,
    OverlayComponent,
    TranslatePipe,
    ButtonComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class W8BenFormTooltipComponent {}

